import React from 'react';
import { useTranslation } from 'react-i18next';

import classes from './styles.module.scss';

function SpaceCalculatorButton({ onClick }: { onClick: () => void }) {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            className={classes.triggerButton}
            onClick={onClick}
            data-testid="space-calculator-button"
        >
            <span className={classes.triggerPrompt}>
                {t('standardUnitListing:spaceCalculator:notSureAboutSizing')}
            </span>
            <span className={classes.triggerLabel}>
                {t('standardUnitListing:spaceCalculator:title')}
            </span>
        </button>
    );
}

export default SpaceCalculatorButton;
